import PDFMerger from "pdf-merger-js/browser";
import axios from "axios";
import { addPdfToMergerWithFallback } from "./rasterizeEncryptedPdf";

export async function mergePdfsFromBlobOrUrlList(
  blobOrUrlList: (Blob | string)[],
  onProgress?: (i: number, total: number) => any
) {
  const merger = new PDFMerger();

  let size = blobOrUrlList.length;

  for (let i = 0; i < blobOrUrlList.length; i++) {
    const item = blobOrUrlList[i];

    let blob = null;

    if (typeof item !== "string") {

      blob = item;

    } else {

      try {

        const { data } = await axios({
          method: "get",
          url: item,
          responseType: "blob",
        });


        blob = data

      } catch (err) {
        size -= 1;
        continue;
      }
    }

    onProgress?.(i, size);
    try {
      // tenta o merge direto; se o PDF for ilegível pelo pdf-lib (ex.:
      // criptografado), faz fallback rasterizando com pdf.js.
      await addPdfToMergerWithFallback(merger, blob!);
    } catch (err) {
      console.error("Erro ao anexar PDF", item, err);
    }
  }

  return await merger.saveAsBlob();
}
